var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ArrayWidget } from './array.widget';
import { CheckboxWidget } from './checkbox.widget';
import { FileWidget } from './file.widget';
import { IntegerWidget } from './integer.widget';
import { ObjectWidget } from './object.widget';
import { RadioWidget } from './radio.widget';
import { RangeWidget } from './range.widget';
import { SelectWidget } from './select.widget';
import { StringWidget } from './string.widget';
import { TextAreaWidget } from './textarea.widget';
import { ButtonWidget } from './button.widget';
import { ButtonGroupWidget } from './buttongroup.widget';
import { MessageWidget } from './message.widget';
import { POPQWidget } from './popq.widget';
import { TagListWidget } from './taglist.widget';
import { DividerWidget } from './divider.widget';
import { DurationDaysWidget } from "./custom/durationdays.widget";
import { DefaultWidgetRegistry } from '../angular2-schema-form-shim';
var SPWidgetRegistry = (function (_super) {
    __extends(SPWidgetRegistry, _super);
    function SPWidgetRegistry() {
        var _this = _super.call(this) || this;
        _this.register('array', ArrayWidget);
        _this.register('object', ObjectWidget);
        _this.register('string', StringWidget);
        _this.register('search', StringWidget);
        _this.register('tel', StringWidget);
        _this.register('url', StringWidget);
        _this.register('email', StringWidget);
        _this.register('password', StringWidget);
        _this.register('color', StringWidget);
        _this.register('date', StringWidget);
        _this.register('date-time', StringWidget);
        _this.register('time', StringWidget);
        _this.register('hidden', StringWidget);
        _this.register('integer', IntegerWidget);
        _this.register('number', IntegerWidget);
        _this.register('range', RangeWidget);
        _this.register('textarea', TextAreaWidget);
        _this.register('file', FileWidget);
        _this.register('select', SelectWidget);
        _this.register('radio', RadioWidget);
        _this.register('boolean', CheckboxWidget);
        _this.register('checkbox', CheckboxWidget);
        _this.register('button', ButtonWidget);
        _this.register('buttongroup', ButtonGroupWidget);
        _this.register('message', MessageWidget);
        _this.register('popq', POPQWidget);
        _this.register('taglist', TagListWidget);
        _this.register('divider', DividerWidget);
        _this.register('durationdays', DurationDaysWidget);
        _this.setDefaultWidget(StringWidget);
        return _this;
    }
    SPWidgetRegistry.prototype.register = function (type, widget) {
        _super.prototype.register.call(this, type, widget);
    };
    return SPWidgetRegistry;
}(DefaultWidgetRegistry));
export { SPWidgetRegistry };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/registry.ts.pre-build-optimizer.js